import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../util/bbHelpers";
import {HashLink as Link} from "react-router-hash-link";

export const BizInitialTourFree_Social = {
    url: `/board/BreachRisk/Business/Report/Social`,
    type: `tutorial`,
    user: {
        first_login: true,
    },
    entity: {
        verified_ownership: true,
        hasScores: null,
        subscription: "Business",
        subLevel: ["free"],
    },
    openingModal: {
        icon: null,
        heading: "Social Testing Beyond The Usual",
        description: <div className={"text-center"}>
            <p>
                Social Testing capabilities find identities and send carefully crafted attacks. In addition to seeing if your team <i>opens</i> these attacks, we report back on whether we were able to execute an attack.
            </p>
            <p>
                Customers on BreachRisk&trade; Free won't have access to social testing or identities information.
            </p>
            <p>
                You can upgrade your service on the <Link to={`/board/settings/subscription#manageSubscription`} className={"text-white"}><u> Manage Subscription </u></Link> page.
            </p>
        </div>
    },
    tourSteps: {
        1: {
            step: 1,
            title: "Identities Trends",
            content: "Track the visibility of your company's social landscape over time.",
            scrollToElement: document.querySelector("#tourSocialStepOne"),
            anchorEl: "#tourIdSocialHistory",
            element: null,
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: "750px",
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}